import { render, staticRenderFns } from "./failed-modal.vue?vue&type=template&id=270be848&scoped=true"
import script from "./failed-modal.vue?vue&type=script&lang=js"
export * from "./failed-modal.vue?vue&type=script&lang=js"
import style0 from "./failed-modal.vue?vue&type=style&index=0&id=270be848&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270be848",
  null
  
)

export default component.exports